/** Per-tick input bitmask (ARCHITECTURE §4.1). */
export type InputBits = number

export const JUMP = 1
// Bits 2 (slide), 4 (sprint) and 8 (slow) are retired (D-044, D-045): still valid on the wire,
// so older clients are not kicked, but the sim ignores them.
export const ITEM = 16
export const PET = 32

/** Highest valid bitmask value. */
export const INPUT_MAX = 63

/** True on the tick a button goes from up to down. */
export function pressed(bits: InputBits, prevBits: InputBits, button: number): boolean {
  return (bits & button) !== 0 && (prevBits & button) === 0
}
